/**
 * Filter drawer "View N items" button (collection and search pages, Nike / Baymard pattern).
 * The live form re-renders the page's count partial after every filter change; its hidden
 * [data-results-count] holds the filtered product count. This copies that count into every
 * [data-view-items] label using its data-label-one / data-label-other ("[count]" placeholder).
 * The search drawer has its own [data-results-count]; it is ignored.
 */
function pageCount() {
  for (const el of document.querySelectorAll('[data-results-count]')) {
    if (!el.closest('#predictive-search')) return el;
  }
  return null;
}

function sync() {
  const countEl = pageCount();
  if (!countEl) return;
  const count = Number.parseInt(countEl.textContent.trim(), 10);
  if (Number.isNaN(count)) return;
  for (const label of document.querySelectorAll('[data-view-items]')) {
    const template = count === 1 ? label.dataset.labelOne : label.dataset.labelOther;
    if (!template) continue;
    const text = template.replace('[count]', String(count));
    if (label.textContent !== text) label.textContent = text;
  }
}

const root = document.querySelector('main') || document.body;
new MutationObserver(() => sync()).observe(root, { childList: true, subtree: true, characterData: true });
sync();
